<template>
  <CHeader fixed with-subheader light class="px-3">
    <CHeaderNavLink to="/" class="d-flex align-items-center">
      <div style="width: 190px;">
        <img src="/img/logo-galileo-color-2x.png" alt="" class="img-responsive" style="max-height: 30px; object-fit: contain;">
      </div>
    </CHeaderNavLink>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <div class="mx-auto d-lg-none">
    </div>
    <CHeaderNav class="d-md-down-none mr-auto">
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <div class="mr-3">
        {{ login }}
      </div>
      <div class="logout" @click="logout" data-cy="logout">
        <i class="fa fa-lock"></i>
        <span>
          Logout
        </span>
      </div>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import { freeSet } from '@coreui/icons';
import { ActiveUser } from '@/services/user';

export default {
  name: 'TheHeader',
  freeSet,
  data() {
    return {
      login: ActiveUser.get()?.email,
    };
  },
  methods: {
    logout() {
      ActiveUser.clear();
      this.$router.replace({ name: 'Login' });
    },
  },
};
</script>

<style scoped lang="scss">
.logout {
  cursor: pointer;
  border-bottom: 1px solid transparent;

  &:hover {
    border-color: $gray-base;
  }
}
</style>
